import axios from 'axios';
import * as constants from './constants';

const instance = axios.create({
  //baseURL: 'https://babezabe.com/api/v1/',
  baseURL: constants.BASE_URL + '/api',
});

export default instance;
